import {request} from 'helpers/services/utils/request';
import {DELETE, GET, POST, PUT} from 'helpers/services/constants/API_CONSTANTS';
import {
  CREATE_BYOC_VIRTUAL_NUMBER_API,
  DELETE_BYOC_VIRTUAL_NUMBER_API,
  FIND_BYOC_VIRTUAL_NUMBERS_API,
  GET_BYOC_LOCATION_OTTER_BRANDS_API,
  UPDATE_BYOC_VIRTUAL_NUMBER_API
} from 'helpers/services/constants/API_ENDPOINTS';
import {getActiveMerchantsApi} from 'helpers/services/api/merchant';

export const findByocVirtualNumbersApi = async (params) => {
  return request(GET, FIND_BYOC_VIRTUAL_NUMBERS_API(params));
};

export const createByocVirtualNumberApi = async ({
  locationId,
  brandId,
  brandName
}) => {
  return request(POST, CREATE_BYOC_VIRTUAL_NUMBER_API(locationId), {
    data: {brandId, brandName}
  });
};

export const updateByocVirtualNumberApi = async (
  id,
  {locationId, brandId, brandName}
) => {
  return request(PUT, UPDATE_BYOC_VIRTUAL_NUMBER_API(id), {
    data: {locationId, brandId, brandName}
  });
};

export const deleteByocVirtualNumberApi = async (id) => {
  return request(DELETE, DELETE_BYOC_VIRTUAL_NUMBER_API(id));
};

export const getLocationOtterBrandsApi = async (locationId) => {
  return request(GET, GET_BYOC_LOCATION_OTTER_BRANDS_API(locationId));
};

export const searchActiveLocationsApi = async (search) => {
  return getActiveMerchantsApi({search: encodeURIComponent(search), limit: 50});
};
